module.exports = __webpack_public_path__ + "img/templates-unused.cfa21f6e.svg";